export var sanitizeOrganizationId = function(orgId) {
    if (!orgId) {
        return undefined;
    }
    return orgId.replace(/[^a-zA-Z0-9-]/g, "");
};
export var sanitizeHostedSearchPageId = function(searchPageId) {
    if (!searchPageId) {
        return undefined;
    }
    return searchPageId.replace(/[^a-zA-Z0-9\-]/g, "");
};
export var sanitizeClassicHostedSearchPageName = function(searchPageName) {
    if (!searchPageName) {
        return undefined;
    }
    return searchPageName.replace(/[^a-zA-Z0-9\-_]/g, "");
};
export var sanitizeRegion = function(region) {
    if (!region) {
        return undefined;
    }
    return region.replace(/[^a-zA-Z]/g, "");
};

//# sourceMappingURL=Sanitization.js.map